import { useCallback } from 'react';
import { useArchiveNotificationMutation } from '../api';


export type UseArchiveNotificationProps = {
    userId: string;
    onError?: (error: any) => void;
};

export function useArchiveNotification({ userId, onError }: UseArchiveNotificationProps) {
    const [archiveNotificationMutation, { isLoading }] = useArchiveNotificationMutation();

    const archiveNotification = useCallback(async (notificationId: string) => {
        try {
            await archiveNotificationMutation({ notificationId, userId }).unwrap();

        } catch (error) {
            console.error('Error archiving notification:', error);
            onError?.(error);
        }
    }, [archiveNotificationMutation, userId, onError]);

    return {
        archiveNotification,
        isLoading
    };
}
